import '../../sass/layout/sections/section-categories.scss';



import Swiper from 'swiper';
import {
    Pagination,
    Autoplay
} from 'swiper/modules';

const swiperCategories = document.getElementById('swiperCategories');

if (swiperCategories) {
    const pagination = swiperCategories.querySelector('.swiper-pagination');
    const swiper = new Swiper(swiperCategories, {
        modules: [Pagination, Autoplay],
        loop: false,
        speed: 500,
        slidesPerView: 'auto',
        pagination: {
            el: pagination,
        },
        autoplay: true,
        autoplay: {
            delay: 5000,
        },
        breakpoints: {
            1024: {
                slidesPerView: 5,
            }
        }
    })
    const slides = swiperCategories.querySelectorAll('.swiper-categories__slide');
    slides.forEach(el => {
        el.addEventListener('click', e => {
            window.location = el.querySelector('.btn').href;
        })
    })
}